import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ApiService } from '../../services/api.service';

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const isValid = await ApiService.verifyToken();
                setIsAuthenticated(isValid);
            } catch (error) {
                console.error('Erreur d\'authentification:', error);
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '1.2rem',
                color: '#DE995C'
            }}>
                Vérification de l'authentification...
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute; 